import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            特色优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            为什么选择成全影院
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 mb-5">
                <i className={`${item.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-medium text-foreground-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}